import { ColorPicker, UpsellGuard } from '@components'

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { Scope } from '../../../../../../../../enums/scope'
import { TrackingContext } from '../../../../../../../../enums/trackingContext'
import { useFormContext } from '../../../../../../../../hooks'
import type { InvoicingSettingsSection } from '../../../../../../enums/invoicingSettingsSection'
import { useTrackInvoicingSettings } from '../../../../../../hooks/useTrackInvoicingSettings'
import type { LogoAndBrandingSettingsFormSchema } from '../../../../types/logoAndBrandingSettingsFormSchema'

interface DefaultColorPickerProps {
  trackingSection?: InvoicingSettingsSection
}

export const DefaultColorPicker = ({ trackingSection }: DefaultColorPickerProps): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings({ section: trackingSection })

  const {
    FormItem,
    trigger,
    formState: { errors },
  } = useFormContext<LogoAndBrandingSettingsFormSchema>()

  return (
    <FormItem
      name="templateColor"
      label={t('external_invoices.appearance_settings.modal.default_color')}
      render={({ field: { id, onChange, value } }) => {
        return (
          <UpsellGuard scope={Scope.InvoiceDesignerUpsell} trackingContext={TrackingContext.InvoiceDesigner}>
            <ColorPicker
              id={id}
              isError={!!errors.templateColor}
              onChange={(props) => {
                onChange(props)
                trigger('templateColor')
                trackInvoicingSettings('Color changed')
              }}
              value={value}
            />
          </UpsellGuard>
        )
      }}
    />
  )
}
